'use strict';

module.exports = require('./components/DocEditor/objectEditorEnhancer').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/objectEditorEnhancer.js
// module id = 1802
// module chunks = 0